module.exports = __webpack_public_path__ + "img/arrow.71b951df.png";